import React from 'react';

import {graphql} from 'gatsby';
import {Box, LayoutGrid, StyledRichContent, SEOWithQuery} from 'src/components/shared';
import {Typography} from 'src/components/shared/typography';
import {Icon, Icons} from 'src/svgs';
import * as copy from 'src/utils/copy';
import {legalListStyle} from 'src/utils/styles';
import styled from 'styled-components/macro';

import {TermsOfServicePageQuery} from 'graphql-types';

const {P0, P2} = Typography;

export const query = graphql`
  query TermsOfServicePage {
    doc: sanityPublicTermsOfService(_id: {eq: "publicTermsOfService"}) {
      _updatedAt(formatString: "MMM D, YYYY")
      content: _rawContent
      copyright
    }
  }
`;

type TermsOfServicePageProps = {
  data: TermsOfServicePageQuery;
};

const RichContent = styled(StyledRichContent).attrs({})`
  ${legalListStyle}
`;

export const TermsOfServicePage: React.FC<TermsOfServicePageProps> = ({data}) => {
  return (
    <Box backgroundColor="darkGreen">
      <LayoutGrid>
        <Box gridColumn="1/end">
          <Box textAlign="center" pt="83px" pb="43px" mb="32px">
            <Box width="150px" mb="34px" mx="auto">
              <Icon aria-label={copy.termsOfService.ariaLabels.logo} icon={Icons.logo} color="cream" />
            </Box>
            <P0 color="cream" mb="21px">
              {copy.termsOfService.companyName}
            </P0>
            <P0 color="cream" mb="21px">
              {copy.termsOfService.title}
            </P0>
            {!!data.doc?._updatedAt && (
              <P0 color="cream" mb="21px">
                {copy.termsOfService.lastUpdatedLabel}: {data.doc._updatedAt}
              </P0>
            )}
          </Box>
          <RichContent blocks={data.doc?.content} />
          {!!data.doc?.copyright && (
            <>
              <Box as="hr" my="24px" />
              <P2 color="cream" textAlign="center" mb="40px">
                {data.doc.copyright}
              </P2>
            </>
          )}
        </Box>
      </LayoutGrid>
      <SEOWithQuery title={copy.seo.termsOfServiceTitle} noIndex />
    </Box>
  );
};

export default TermsOfServicePage;
